<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="From"><br>
                                <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" 
                                :placeholder="['Start Time', 'End Time']" style="width:100%"
                                 @ok="handleOk"
                                @change="handleDateChange"
                                />
                            </base-input>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Sites">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'" @change="fetchCashiers">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Cashier">
                                <a-select v-model="inputCashier" showSearch placeholder="All Cashiers" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                    <a-select-option v-for="option in cashierOptions" :key="option.id" :value="option.id">{{option.first_name}} {{option.last_name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')+`.xls`" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import reportUtils from '../../components/reportUtils'

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                currDate: moment().format("L_LT").split(":").join(";"),
                inputSite: [],
                inputCashier: 0,
                inputPromo: 0,
                openCheckEndorsementReport: [],
                site_type: "ho",
                siteOptions: [],
                cashierOptions: [],
                JsonData: [],
            }
        },
        mounted: async function () {
            var component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]
            await this.fetchCashiers()

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }

        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        components:{
            VueJsonToCsv
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            openNotificationWithIcon(type, msg) {
                this.$notification[type]({
                    message: 'No Data',
                    description: msg 
                });
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },
            handleDateChange(dates) {
                this.inputDate = dates;
            },
            validateDateRange(dates) {
                if (!dates || dates.length !== 2) return;

                const [start, end] = dates;
                if (!start || !end) return;

                const isAllSites = !this.inputSite || this.inputSite.length === 0;
                const maxMonths = isAllSites ? 1 : 6;

                const diffInMonths = moment(end).diff(moment(start), 'months', true);
                if (diffInMonths > maxMonths) {
                    if (this.$message && this.$message.error) {
                        if (maxMonths > 1) {    
                            this.$message.error(`You can only select up to ${maxMonths} month${maxMonths > 1 ? 's' : ''} range for selected sites.`);
                        } else {
                            this.$message.error(`You can only select up to ${maxMonths} month${maxMonths > 1 ? 's' : ''} range for All Sites.`);
                        }
                    }
                    this.inputDate = null;
                }
            },
            handleOk(dates) {
               this.validateDateRange(dates);
            },
            async fetchCashiers() {
                const users = await HTTPRequest.getRequest(
                    this.endPoint + 'users/get_valid_cashiers?site_id=' + (this.inputSite || []),
                    null
                );

                this.cashierOptions = users || []
                this.cashierOptions.push({ id: 0, first_name: 'All Cashiers', last_name: '' })
                this.cashierOptions.sort((a, b) => {
                    const firstName = (a.first_name || '').localeCompare(b.first_name || '')
                    return firstName || (a.last_name || '').localeCompare(b.last_name || '')
                })
                this.inputCashier = 0
            },
            generateReport: async function () {
                if (!this.inputDate || this.inputDate.length !== 2 || !this.inputDate[0] || !this.inputDate[1]) {
                    if (this.$message && this.$message.error) {
                        this.$message.error("Please select a valid date range before generating the report.");
                        return;
                    }
                }

                this.spinning= true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'open_check_endorsement_report?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&user_id=' + this.inputCashier, null, "BXI-File");

                console.log("data", get_request)

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });

                    let reportLogo = document.getElementById('reportLogo');
                    let headers = [
                        {content: 'Site Name', styles: {halign: 'center'}},
                        {content: 'Transaction Date', styles: {halign: 'center'}},
                        {content: 'Transaction Type', styles: {halign: 'center'}},
                        {content: 'POS Document Status', styles: {halign: 'center'}},
                        {content: 'Order Number', styles: {halign: 'center'}},
                        {content: 'Order Start Time', styles: {halign: 'center'}},
                        {content: 'Transferred Time', styles: {halign: 'center'}},
                        {content: 'Minutes Open/Floating', styles: {halign: 'center'}},
                        {content: 'Amount Unsettled', styles: {halign: 'center'}},
                        {content: 'Endorsed By', styles: {halign: 'center'}},
                        {content: 'Endorsed To', styles: {halign: 'center'}},
                        {content: 'MOD', styles: {halign: 'center'}}
                    ]
                    let detailColStyles = {
                        0: {cellWidth: 24}, 1: {cellWidth: 24}, 2: {cellWidth: 25},
                        3: {cellWidth: 22}, 4: {cellWidth: 23}, 5: {cellWidth: 25},
                        6: {cellWidth: 25}, 7: {cellWidth: 21}, 8: {cellWidth: 25},
                        9: {cellWidth: 28}, 10: {cellWidth: 28}, 11: {cellWidth: 24}
                    }

                    for(var x=0; x < siteSpecific.length; x++){
                        this.openCheckEndorsementReport = siteSpecific[x].report_details || []

                        if(x > 0 && this.openCheckEndorsementReport.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];
                        doc.addImage(reportLogo, "PNG", 10, 5, 15, 15);
                        // report headers
                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        let design_y = 20
                        design_y = design_y + 5;
                        doc.text(15,design_y,`Open Check Endorsement Report`)
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        design_y = design_y + 5;
                        doc.text(15,design_y,"Date Range: " + this.inputDate[0].format('MMMM DD, YYYY hh:mm A')  + " to " + this.inputDate[1].format('MMMM DD, YYYY hh:mm A'))
                        design_y = design_y + 5;
                        doc.text(15,design_y,"Site: " + this.value(this.openCheckEndorsementReport[0], ['SITE_NAME', 'SITE']))
                        this.openCheckEndorsementReport = siteSpecific[x].report_details || []
                        // report data
                        if(this.openCheckEndorsementReport.length > 0){
                            for(let i=0; i < this.openCheckEndorsementReport.length; i++){
                                let reportLine = this.openCheckEndorsementReport[i]
                                let detail = [
                                    {
                                        content: this.safeText(this.value(reportLine, ['SITE_NAME', 'SITE'])),
                                        styles: { halign: 'center' }
                                    },
                                    {
                                        content: this.formatDate(this.value(reportLine, ['TRANSACTION_DATE'])),
                                        styles: { halign: 'center' }
                                    },
                                    {
                                        content: this.safeText(this.value(reportLine, ['TRANSACTION_TYPE'])),
                                        styles: { halign: 'center' }
                                    },
                                    {
                                        content: this.posDocumentStatusName(this.value(reportLine, ['POS_DOCUMENT_STATUS', 'DOCUMENT_STATUS', 'STATUS'])),
                                        styles: { halign: 'center' }
                                    },
                                    {
                                        content: this.safeText(this.value(reportLine, ['ORDER_NUMBER', 'ORDER_NO'])),
                                        styles: { halign: 'center' }
                                    },
                                    {
                                        content: this.formatDateTime(this.value(reportLine, ['ORDER_START_TIME', 'ORDER_STARTED_AT'])),
                                        styles: { halign: 'center' }
                                    },
                                    {
                                        content: this.formatDateTime(this.value(reportLine, ['TRANSFERRED_TIME', 'TRANSFERRED_AT'])),
                                        styles: { halign: 'center' }
                                    },
                                    {
                                        content: this.formatMinutes(reportLine),
                                        styles: { halign: 'right' }
                                    },
                                    {
                                        content: this.formatAmount(this.value(reportLine, ['AMOUNT_UNSETTLED', 'UNSETTLED_AMOUNT'])),
                                        styles: { halign: 'right' }
                                    },
                                    {
                                        content: this.safeText(this.value(reportLine, ['ENDORSED_BY', 'ENDORSED_BY_NAME'])),
                                        styles: { halign: 'center' }
                                    },
                                    {
                                        content: this.safeText(this.value(reportLine, ['ENDORSED_TO', 'ENDORSED_TO_NAME'])),
                                        styles: { halign: 'center' }
                                    },
                                    {
                                        content: this.safeText(this.value(reportLine, ['MOD', 'MANAGER_ON_DUTY', 'MOD_NAME'])),
                                        styles: { halign: 'center' }
                                    }
                                ]

                                reportData.push(detail)
                                
                                if(i == this.openCheckEndorsementReport.length-1){

                                    reportData.push(Object.assign({}, ["rowLine"]))

                                    //create table
                                    design_y = design_y + 10
                                    doc.autoTable({
                                        startY: design_y, 
                                        head: [headers],
                                        body: reportData, 
                                        theme: 'plain',
                                        tableWidth: 'wrap',
                                        headStyles: {
                                            lineWidth: 0.15
                                        },
                                        styles: {
                                            cellPadding: 1.0, fontSize: 8,
                                            halign: 'right'
                                        },
                                        columnStyles: detailColStyles,
                                        didParseCell: function(data) {
                                            if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                                data.cell.styles.fillColor = [0, 0, 0]
                                                data.cell.styles.fontSize = 1
                                                data.cell.styles.cellPadding = 0
                                            } else if (data.row.section == 'body' && data.row.raw[6] == 'Total :'){
                                                data.cell.styles.fontStyle = 'bold'
                                            }
                                        }
                                    });
                                } else {
                                    // subtotal = 0
                                    // grand_total = 0
                                }
                            }
                        }
                    }

                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    }
                    let pageCount = doc.internal.getNumberOfPages();
                    let footer_x = 340
                    let footer_y = 205
                    for(let i = 1; i <= pageCount; i++) { 
                        doc.setPage(i);
                        reportUtils.pdfTools.addFooter(doc, printed_by, "Open Check Endorsement Report", footer_x, footer_y, i, pageCount)
                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                }
                this.spinning= false;
            },
            generateFile: async function() {
                if (!this.inputDate || this.inputDate.length !== 2 || !this.inputDate[0] || !this.inputDate[1]) {
                    if (this.$message && this.$message.error) {
                        this.$message.error("Please select a valid date range before generating the report.");
                        return;
                    }
                }

                this.spinning= true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'open_check_endorsement_report?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&user_id=' + this.inputCashier, null, "BXI-File");

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let site_specific = [];
                    for(var x=0; x < siteSpecific.length; x++){
                        this.openCheckEndorsementReport = siteSpecific[x].report_details || []

                        let headers = ['Site Name', 'Transaction Date', 'Transaction Type', 'POS Document Status', 'Order Number', 'Order Start Time', 'Transferred Time', 'Minutes Open/Floating', 'Amount Unsettled', 'Endorsed By', 'Endorsed To', 'MOD']
                        
                        let reportData = []
                        if(this.openCheckEndorsementReport.length > 0){
                            // let grand_gross = 0
                            for(let i=0; i < this.openCheckEndorsementReport.length; i++){
                                let reportLine = this.openCheckEndorsementReport[i]

                                let detail = [
                                    {
                                        content: this.safeText(this.value(reportLine, ['SITE_NAME', 'SITE'])),
                                        styles: { halign: 'center' }
                                    },
                                    {
                                        content: this.formatDate(this.value(reportLine, ['TRANSACTION_DATE'])),
                                        styles: { halign: 'center' }
                                    },
                                    {
                                        content: this.safeText(this.value(reportLine, ['TRANSACTION_TYPE'])),
                                        styles: { halign: 'center' }
                                    },
                                    {
                                        content: this.posDocumentStatusName(this.value(reportLine, ['POS_DOCUMENT_STATUS', 'DOCUMENT_STATUS', 'STATUS'])),
                                        styles: { halign: 'center' }
                                    },
                                    {
                                        content: this.safeText(this.value(reportLine, ['ORDER_NUMBER', 'ORDER_NO'])),
                                        styles: { halign: 'right' }
                                    },
                                    {
                                        content: this.formatDateTime(this.value(reportLine, ['ORDER_START_TIME', 'ORDER_STARTED_AT'])),
                                        styles: { halign: 'center' }
                                    },
                                    {
                                        content: this.formatDateTime(this.value(reportLine, ['TRANSFERRED_TIME', 'TRANSFERRED_AT'])),
                                        styles: { halign: 'right' }
                                    },
                                    { content: this.formatMinutes(reportLine), styles: { halign: 'right' } },
                                    { content: this.formatAmount(this.value(reportLine, ['AMOUNT_UNSETTLED', 'UNSETTLED_AMOUNT'])), styles: { halign: 'right' } },
                                    { content: this.safeText(this.value(reportLine, ['ENDORSED_BY', 'ENDORSED_BY_NAME'])), styles: { halign: 'center' } },
                                    { content: this.safeText(this.value(reportLine, ['ENDORSED_TO', 'ENDORSED_TO_NAME'])), styles: { halign: 'center' } },
                                    { content: this.safeText(this.value(reportLine, ['MOD', 'MANAGER_ON_DUTY', 'MOD_NAME'])), styles: { halign: 'center' } }
                                ]

                                reportData.push(detail)
                            }
                        }

                        let newJsonData = reportData.map(row => Object.assign({}, ...headers.map((header, index) => ({
                            [header]: row[index].content
                        }))));
                        site_specific.push(newJsonData)
                    }
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    this.openNotificationWithIcon('error', 'No Data Found');
                }
                this.spinning= false;
            },
            clearJsonData(){
                this.JsonData = [];
            },
            posDocumentStatusName(status) {
                const statusNames = {
                    P: 'Posted',
                    V: 'Voided',
                    R: 'Refunded',
                    A: 'Cancelled',
                    S: 'Suspended'
                }
                return statusNames[status] || this.safeText(status)
            },
            safeText(v) {
              if (v === null || v === undefined || v === '') return ''
              if (typeof v === 'object') return Object.values(v).join(' ')
              return v
            },
            value(reportLine, keys) {
                if (!reportLine) return ''
                const reportKeyByLowerCase = Object.keys(reportLine).reduce((result, key) => {
                    result[key.toLowerCase()] = key
                    return result
                }, {})
                const key = keys
                    .map(key => reportKeyByLowerCase[key.toLowerCase()])
                    .find(key => key && reportLine[key] !== null && reportLine[key] !== undefined)
                return key ? reportLine[key] : ''
            },
            formatDate(value) {
                return value ? moment(value).format('MM-DD-YYYY') : ''
            },
            formatDateTime(value) {
                return value ? moment(value).format('MM-DD-YYYY hh:mm A') : ''
            },
            formatMinutes(reportLine) {
                const started = this.value(reportLine, ['ORDER_START_TIME', 'ORDER_STARTED_AT'])
                const transferred = this.value(reportLine, ['TRANSFERRED_TIME', 'TRANSFERRED_AT'])
                if (started && transferred) return moment(transferred).diff(moment(started), 'minutes')

                return this.safeText(this.value(reportLine, ['OPEN_FLOATING_MINUTES', 'MINUTES_OPEN_FLOATING', 'OPEN_MINUTES']))
            },
            formatAmount(value) {
                if (value === null || value === undefined || value === '') return ''
                const amount = Number(value)
                return Number.isNaN(amount) ? this.safeText(value) : this.convertToCurrency(amount)
            }
        }
    };
</script>

<style></style>
